import { Build, Job, Step } from "~/components/build/Show/lib/types";
import { queryOptions, UseQueryOptions } from "@tanstack/react-query";
import fetcher from "~/components/build/Show/lib/fetcher";
import { jobQueryKey, setJobQueryData } from "~/components/build/Show/lib/queries/job";

export const stepJobsQueryKey = (build: Build, stepUuid: Step["uuid"]) => {
  return ["build", build.id, "steps", stepUuid, "jobs"];
};

export const stepJobsQueryOptions = (
  build: Build,
  stepUuid: Step["uuid"],
  queryOptionsArgs: Omit<UseQueryOptions<Job[]>, "queryKey" | "queryFn"> = {},
) => {
  return queryOptions({
    queryKey: stepJobsQueryKey(build, stepUuid),
    queryFn: ({ client: queryClient, signal }) =>
      fetchStepJobs(build.buildDataBasePath, stepUuid, signal).then((jobs) => {
        jobs.forEach((job) => setJobQueryData(build, job, queryClient));

        return jobs;
      }),
    ...queryOptionsArgs,
  });
};

function fetchStepJobs(
  buildDataBasePath: Build["buildDataBasePath"],
  stepUuid: Step["uuid"],
  signal: AbortSignal,
) {
  const url = new URL(`${buildDataBasePath}/steps/${stepUuid}/jobs`, window.location.origin);

  return fetcher<Job[]>(url, true, { signal });
}
